//NPM Packages
import { React, useContext } from "react";
import styled from "styled-components";

//Context
import MyContext from "../context/MyContext";

//Components
import Docs from "../components/DemoLeads/Docs";

//Shared Components
import Authentication from "../components/Shared/Authentication";
import Header from "../components/Shared/Header";
import { Wrapper } from "../components/styles/Wrapper.styled";

const FormWrapper = styled.div`
  padding: ${(props) => props.theme.space[1]};

  @media ${({ theme }) => theme.device.mobileL} {
    padding: ${(props) => props.theme.space[2]};
  }

  @media ${({ theme }) => theme.device.laptop} {
    padding: ${(props) => props.theme.space[3]};
  }
`;

const WhiteForm = styled.div`
  --shadow-color: ${({ shadow }) => shadow || "0deg 0% 50%"};
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: ${({ border }) => border || "none"};
  box-shadow: ${({ theme }) => theme.elevations.medium};
  background-color: ${({ bg }) => bg || "#fff"};
  padding: ${({ theme }) => theme.space[4]};
`;

export default function DocsForm(props) {
  const {
    //Authentication
    idVerification,
    idVerificationRequired,
  } = useContext(MyContext);

  return (
    <Wrapper>
      <Header
        name="Laminin Demo Application"
        description="Laminin Demo Application"
        logoPath="./images/laminin-demo-white-bg.png"
      />
      {!idVerification && idVerificationRequired && (
        <Authentication phone="0100 546 546" />
      )}

      {(idVerification || !idVerificationRequired) && (
        <FormWrapper>
          <WhiteForm>
            <Docs
              name="Laminin"
              formName="Demo Form"
              phone="0100 546 546"
            />
          </WhiteForm>
        </FormWrapper>
      )}
    </Wrapper>
  );
}
